/**
 * Application constants
 *
 * Single source of truth for app-wide configuration values
 */

export const APP_VERSION = "1.3.4"
